export default "__VITE_ASSET__BRyQd0h___"